
import "index.scss"
import { createRoot } from "react-dom/client"
import { errorToString } from "shared/misc"
import App from "./app/Public.js"

const root = document.getElementById("root")
if (root === null) {
    throw new Error("Root element not found.")
}
const react = createRoot(root)
try {
    react.render(<App />)
}
catch (e) {
    react.render("<h1 class=\"text-center\">" + errorToString(e) + "</h1>")
}
